// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__-J8_s","insightsList":"newBusinessInsightsMenu_insightsList__2lK3Q","active":"newBusinessInsightsMenu_active___Kdlx"};